import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


function GrupoProdutosExcel(grupos) {
  // Título do relatório
  const titulo = [["Relatório de Grupos de Produtos"]];

  // Cabeçalho atualizado com a coluna "Carga"
  const cabecalho = [["Código do Grupo", "Descrição", "Carga"]];

  // Dados formatados
  const dados = grupos.map(grupo => [
    grupo.COD_GRUPO,
    grupo.DESCRICAO,
    grupo.CARGA === "1" ? "Sim" : "Não"
  ]);

  // Junta tudo: título, linha em branco, cabeçalho e dados
  const planilhaCompleta = [...titulo, [], ...cabecalho, ...dados];

  // Cria a worksheet
  const worksheet = XLSX.utils.aoa_to_sheet(planilhaCompleta);

  // Largura das colunas
  worksheet["!cols"] = [
    { wch: 15 },  // Código do Grupo
    { wch: 40 },  // Descrição
    { wch: 10 },  // Carga
  ];

  // Cria o workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Grupos");

  // Converte o workbook para buffer
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array"
  });

  // Cria o Blob e salva
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });

  saveAs(blob, "Relatorio_Grupos.xlsx");
}


export default GrupoProdutosExcel;
